import styled from 'styled-components';
import HeroBg from '../../../../assests/images/homepage/hero-bg.png';

export const HeroContentWrapper = styled.div`
  height: calc(100vh - 0px);
  background: url(${HeroBg}),
    linear-gradient(252.69deg, #001542 -0.53%, #070f1f 101.52%);
  background-position: center;
  background-repeat: no-repeat;
  .hero-container {
    height: calc(100vh - 104px);
    display: flex;
    align-items: center;
    justify-content: center;
    .main-content {
      width: 70%;
      text-align: center;
      margin-top: 148px;
      @media (max-width: 991px) {
        width: 100%;
      }
      .content {
        margin: 20px auto;
        .content_header {
          display: flex;
          justify-content: center;
          align-items: center;
          .line {
            height: 2.14px;
            background-color: #ffffff;
            width: 200px;
            @media (max-width: 991px) {
              width: 45px;
            }
          }
          .sub-content {
            font-family: 'Poppins';
            font-style: italic;
            font-weight: 400;
            font-size: 25px;
            color: #ffffff;
            margin-left: 10px;
            margin-right: 13px;
            white-space: nowrap;
            @media (max-width: 991px) {
              font-size: 16px;
            }
          }
        }
      }
      .content_header {
        &_heading {
          font-family: 'Poppins';
          font-style: normal;
          font-weight: 600;
          font-size: 48px;
          color: rgba(255, 255, 255, 0.5);
          margin-bottom: 20px;
          @media (max-width: 991px) {
            font-size: 30px;
          }
        }
      }
      @keyframes bounce {
        0% {
          transform: translateY(0);
        }
        50% {
          transform: translateY(-20px);
        }
        100% {
          transform: translateY(0);
        }
      }
      .content-button {
        width: 30%;
        padding: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 60px auto 0;
        animation: bounce 1s infinite;
        & .content-button-image {
          cursor: pointer;
        }

        &_title {
          font-family: 'Poppins';
          font-style: normal;
          font-weight: 600;
          font-size: 21px;
          color: #ffffff;
          padding-right: 20px;
          transform: skew(25deg);
          @media (max-width: 991px) {
            font-size: 16px;
          }
        }
        &_icon {
          border-radius: 50%;
          background-color: #ffffff;
          padding: 3px;
          transform: skew(25deg);
        }
      }
    }
  }
`;
